module.exports = __webpack_public_path__ + "gw.svg?6c6e90fac2cf2f4cab03d1a855a762a5";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/gw.svg
// module id = 1268
// module chunks = 27